import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import AuthService from 'services/auth'
import cutileiApi from 'services/cutileiApi'
import { logApiError } from 'services/apiError'
import AlertDialog from 'components/AlertDialog'
import PasswordInput from 'components/Inputs/PasswordInput'
import PasswordStrengthBar from 'components/PasswordStrengthBar'
import passwordValidator from 'validators/passwordValidator'
import MainButton from 'components/Buttons/MainButton'
import { Formik } from 'formik'

import {
  Container,
  Form,
  SubTitle,
  Row,
  FormField,
  InfoText,
  WarningText
} from '../../styles'

export default function ChangePassword () {
  const [showOkDialog, setShowOkDialog] = useState (false)
  const user = AuthService.getUser ()
  const token = AuthService.getToken ()
  const isBusiness = AuthService.isBusiness ()
  const businessId = AuthService.getBusinessId ()
  const navigate = useNavigate ()

  const toggleOkDialog = () => setShowOkDialog (!showOkDialog)

  return (
    <Container>
      <Formik
        validationSchema={passwordValidator}
        initialValues={{
          'password': '',
          'password_confirmation': ''
        }}
        onSubmit={async (values, { setSubmitting }) => {
          const url = isBusiness
            ? `/businesses/${businessId}`
            : `/businesses/${businessId}/professionals/${user.id}`

          try {
            await cutileiApi.put (url, {password: values.password}, {
              headers: {
                'Authorization': `Bearer ${token}`
              }
            })

            setSubmitting (false)
            toggleOkDialog ()
          } catch (error) {
            setSubmitting (false)
            logApiError (error)
          }
        }}
      >
        {({
          values,
          errors,
          touched,
          isSubmitting,
          handleChange,
          handleBlur,
          handleSubmit
        }) => (
          <Form style={{width: 480}}>
            <SubTitle>Alterar senha</SubTitle>
            <Row>
              <FormField style={{margin: 0}}>
                <PasswordInput
                  placeholder='Nova senha'
                  value={values.password}
                  onChange={handleChange ('password')}
                  onBlur={handleBlur ('password')}
                />
                {touched.password && errors.password && (
                  <WarningText>
                    {errors.password}
                  </WarningText>
                )}
                <PasswordStrengthBar password={values.password}/>
              </FormField>
            </Row>
            <Row>
              <FormField style={{margin: 0}}>
                <PasswordInput
                  placeholder='Confirmar senha'
                  value={values.password_confirmation}
                  onChange={handleChange ('password_confirmation')}
                  onBlur={handleBlur ('password_confirmation')}
                />
                {touched.password_confirmation && errors.password_confirmation && (
                  <WarningText>
                    {errors.password_confirmation}
                  </WarningText>
                )}
              </FormField>
            </Row>
            <InfoText style={{marginBottom: 15}}>
              Ao alterar sua senha, você será deslogado de todos os dispositivos onde estiver logado, exceto este.
            </InfoText>
            <MainButton
              label='Alterar senha'
              onClick={handleSubmit}
              disabled={isSubmitting}
              loading={isSubmitting}
              width={140}
            />
            <AlertDialog
              visible={showOkDialog}
              title='Sucesso'
              message='Senha alterada!'
              confirmText='Ok'
              onConfirm={() => navigate ('/business', { replace: true })}
              onClose={() => navigate ('/business', { replace: true })}
            />
          </Form>
        )}
      </Formik>
    </Container>
  )
}
